export default "__VITE_ASSET__kKjUT3Sf__"